import React from 'react';
import tickIcon from '../img/tickIcon.svg';
import closeIcon from '../img/close.svg';

const ThankYouPopup = ({ onClose }) => {
    return (
        <div className="thank-you-popup-overlay" onClick={onClose}>
            <div className="thank-you-popup" onClick={(e) => e.stopPropagation()}>
                <button className="thank-you-popup-close" onClick={onClose}>
                    <img src={closeIcon} alt="Close" />
                </button>
                <div className="thank-you-popup-icon">
                    <img src={tickIcon} alt="Success" />
                </div>
                <h1 className="thank-you-popup-title">Thank you</h1>
                <p className="thank-you-popup-message">
                    Your message has been sent and a member of the Epilog team will get back to you within 2 working days.
                </p>
                <button className="thank-you-popup-button" onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
};

export default ThankYouPopup;
